import { gql } from "@apollo/client";

export const UPDATE_TEMPLATE_SETTINGS = gql`
  mutation updateTemplateSettings(
    $templateId: String
    $clientIdentifier: String
    $input: TemplateSettingsInput
  ) {
    invoiceInterpretation {
      updateTemplateSettings(
        templateId: $templateId
        clientIdentifier: $clientIdentifier
        input: $input
      ) {
        success
      }
    }
  }
`;
